<sc-loading-spinner>
    <div class="documents-list">
    <ng-container *ngFor="let dp of documentPreviews">
        <app-transport-document-item [preview]="dp" (click)="listItemClick(dp)">
        </app-transport-document-item>
    </ng-container>
</div>
</sc-loading-spinner>